export default __webpack_public_path__ + "static/media/buddy_magnet_1.6fe6e73b.png";